module.exports = __webpack_public_path__ + "media/components/VendingCart/assets/extensions/6-display-fb78f3ac8cf966ff5dfbe34cfb7a7f46.png";